import React, { useEffect, useState } from 'react'
import { Row, Col, Input, Button } from 'antd'
import {
  DollarCircleOutlined,
  WalletOutlined,
  RiseOutlined,
  SettingOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons'
import NumberFormat from 'react-number-format'
import * as web3Service from '../../blockchain/web3.service'
import { useWeb3React } from '@web3-react/core'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventEmitter from '../../Utils/EventEmitter'

export default function DragonHiringWidget() {

  const [estimatedMiners, setEstimatedMiners] = useState(0)
  const [calculatedMiners, setCalculatedMiners] = useState(0.0)
  const [depositAmount, setDepositAmount] = useState(1)
  const [walletBalanceInBNB, setWalletBalanceInBNB] = useState(0.00)
  const [walletBalanceInUSD, setWalletBalanceInUSD] = useState(0.00)
  const [minDepositAmount, setMinDepositAmount] = useState(0.00)
  const [maxDepositAmount, setMaxDepositAmount] = useState(0.00)
  const [isHiringLoading, setIsHiringLoading] = useState(false)
  const [referralFee, setReferralFee] = useState(0.00)
  const [devFee, setDevFee] = useState(0.00)

  const { account, library } = useWeb3React()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchReferralFee()
    fetchMinAndMaxDepositAmounts()
    fetchDevFee()
  }, [])

  const fetchMinAndMaxDepositAmounts = async () => {
    const maxDepositAmountResponse = await web3Service.getMaxDepositAmount()
    const minDepositAmountResponse = await web3Service.getMinDepositAmount()
    setMinDepositAmount(minDepositAmountResponse || 0)
    setMaxDepositAmount(maxDepositAmountResponse || 0)
  }

  const fetchReferralFee = async () => {
    const referralFeeResponse = await web3Service.getReferralFee()
    if (referralFeeResponse) {
      setReferralFee(referralFeeResponse || 0)
    } else {
      setReferralFee(0.0)
    }
  }

  const fetchDevFee = async () => {
    const devFeeResponse = await web3Service.getDevFee()
    if (devFeeResponse) {
      const actualDevFee = parseFloat(devFeeResponse) * 2
      setDevFee(actualDevFee || 0)
    } else {
      setDevFee(0.0)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const estimatedMinersResponse = await web3Service.getEstimatedMinersFor1BNB()
    if (estimatedMinersResponse) {
      setEstimatedMiners(estimatedMinersResponse)
      setCalculatedMiners(estimatedMinersResponse)
    } else {
      setEstimatedMiners(0)
    }
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (account) {
      const walletBalanceData = await web3Service.getBnbBalanceOfAddress(account)
      setWalletBalanceInBNB(walletBalanceData.walletBalanceInBNB)
      setWalletBalanceInUSD(walletBalanceData.walletBalanceInUSD)
    } else {
      setWalletBalanceInBNB(0.00)
      setWalletBalanceInUSD(0.00)
    }
  }, [account])

  useEffect(() => {
    if (depositAmount && estimatedMiners > 0) {
      const newMinersAmount = parseFloat(estimatedMiners) * parseFloat(depositAmount)
      setCalculatedMiners(newMinersAmount)
    } else {
      setCalculatedMiners(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depositAmount])

  const handleHireDragons = async () => {
    try {

      //get the current url
      const currentURL = window.location.href
      const urlParams = new URL(currentURL)
      const refAddress = urlParams.searchParams.get('ref')
      let referralsLink = ''
      if (refAddress) {
        referralsLink = refAddress
      } else {
        referralsLink = account
      }

      setIsHiringLoading(true)
      //check if user logged into the system
      if (!account) {
        toast.error("Please connect your wallet to continue")
        setIsHiringLoading(false)
        return
      }

      if (parseFloat(walletBalanceInBNB) <= 0) {
        toast.error("You don't have sufficient amount in your wallet to proceed")
        setIsHiringLoading(false)
        return
      }

      if (parseFloat(depositAmount) > parseFloat(walletBalanceInBNB)) {
        toast.error("You don't have sufficient amount in your wallet to proceed")
        setIsHiringLoading(false)
        return
      }

      //check the min max deposit amounts
      if (parseFloat(depositAmount) <= 0) {
        toast.error("Deposit amount should be grater than zero")
        setIsHiringLoading(false)
        return
      }

      //check the min max deposit amounts
      if (parseFloat(depositAmount) > parseFloat(maxDepositAmount)) {
        toast.error("Can not exceed maximum deposit limit")
        setIsHiringLoading(false)
        return
      }

      const response = await web3Service.hireDragons(depositAmount, referralsLink, library.getSigner())
      toast.success("Congratulation! your dragons are ready to fight")
      console.log(response)
      setIsHiringLoading(false)
      EventEmitter.emit('HireDragonEvent', { isSuccess: true })

    } catch (error) {
      let errorMessage = "Something went wrong"
      if (error && error.message) {
        errorMessage = error.message
      }

      if (error && error.data) {
        errorMessage = error.data.message
      }
      toast.error(errorMessage)
      setIsHiringLoading(false)
    }
  }

  return (
    <div className='dragon-hiring-dashboard-container'>
      <div className='dragon-hiring-title'>
        How to hire your dragon
      </div>

      <Row className='dragon-hiring-example-container'>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}
          className='wallet-balance-container mobile-top-margin px-2 mb-4'>
          <div className='wallet-balance-container-inner'>
            <div className='wallet-balance-title'>
              <WalletOutlined style={{ marginRight: '5px' }} />Your Wallet Balance
            </div>

            <div className='wallet-balance-value'>
              <NumberFormat
                className='contract-stats-value-field'
                style={{ marginRight: '5px' }}
                value={walletBalanceInBNB ? walletBalanceInBNB : 0}
                displayType="text"
                decimalScale={3}
                suffix=" BNB"
                thousandSeparator={true}
              />
              (<NumberFormat
                className='contract-stats-value-field'
                value={walletBalanceInUSD ? walletBalanceInUSD : 0}
                displayType="text"
                decimalScale={3}
                prefix="~$"
                thousandSeparator={true}
              />)
            </div>
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}
          className='hiring-facts-container mobile-top-margin px-2 mb-4'>

          <div className='dragon-hiring-data-container'>
            <div className='hiring-title'>
              Dragon hiring facts
            </div>

            <div className='hiring-conversion'>

              <div className='hiring-facts-row'>
                <div className='hiring-conversion-first'>
                  1 BNB :
                </div>
                <div className='hiring-conversion-last'>
                  <span className="dragon-amount">{estimatedMiners ? estimatedMiners : 0}</span> Dragons
                </div>
              </div>

              <div className='hiring-facts-row'>
                <div className='hiring-conversion-first'>
                  <DollarCircleOutlined style={{ marginRight: '5px' }} />Daily Yield :
                </div>
                <div className='hiring-conversion-last'>
                  <span className="dragon-amount">0.0068</span> BNß
                </div>
              </div>

              <div className='hiring-facts-row'>
                <div className='hiring-conversion-first'>
                  <RiseOutlined style={{ marginRight: '5px' }} />APR :
                </div>
                <div className='hiring-conversion-last'>
                  <span className="dragon-amount">2690</span> %
                </div>
              </div>

              <div className='hiring-facts-row'>
                <div className='hiring-conversion-first'>
                  <SettingOutlined style={{ marginRight: '5px' }} />Dev Fee :
                </div>
                <div className='hiring-conversion-last'>
                  <span className="dragon-amount">
                    {devFee}
                  </span> %
                </div>
              </div>

              <div className='hiring-facts-row'>
                <div className='hiring-conversion-first'>
                  <UsergroupAddOutlined style={{ marginRight: '5px' }} />Referral Fee :
                </div>
                <div className='hiring-conversion-last'>
                  <span className="dragon-amount">
                    {referralFee}
                  </span> %
                </div>
              </div>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}
          className='hiring-input-container mobile-top-margin px-2 mb-4'>

          <div className='hiring-input-label-section'>
            1. Deposit BNB ( min {minDepositAmount} BNB, max {maxDepositAmount} BNB )
          </div>

          <div className='input-field-container-hiring mt-2 mb-2'>
            <Input
              type="number"
              defaultValue={1}
              onChange={e => setDepositAmount(e.target.value)}
              className="hiring-dragons-input"
              value={depositAmount}
              placeholder="Enter BNB value"
            />
          </div>

          <div className='hiring-dragon-button-container'>
            <Button
              block
              loading={isHiringLoading}
              className='hiring-dragons-btn'
              onClick={handleHireDragons}
              type="primary"
              shape="round"
              icon={<DollarCircleOutlined />}
              size="large">
              Hire <NumberFormat
                value={calculatedMiners ? calculatedMiners : 0}
                style={{ margin: '0px 5px' }}
                displayType="text"
                decimalScale={3}
                thousandSeparator={false}
              />  Dragons
            </Button>
          </div>
        </Col>
      </Row>


    </div >
  )
}
